export abstract class CellViewModel {
  abstract get value(): unknown;
}
